import React from 'react';
import {
    Container,
    Grid,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import LogTable from './LogTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function LogView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.log')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.log')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <LogTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}